import { FC } from 'react';
import * as React from 'react';
import { Text as TextNode } from '@contentful/rich-text-types';
import triggerTracking from '@blueprint/tracking';
import { renderMarkup, isExternalUri } from '../../functions/helpers';
import { MAIN_SITE_LINK } from '../../constants';
import { GA_CUSTOM_EVENT, GA_CUSTOM_CATEGORY } from '../../constants';
import { trailingSlashCheck } from '../../functions/trailingSlashCheck';
import { Link } from '@zoopla-eng/zds-components/link';

type Props = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    nodeData: Record<string, any>;
};

function renderNodeMarks(node: TextNode): React.ReactNode {
    let result = (
        <React.Fragment key={JSON.stringify(node)}>{node.value}</React.Fragment>
    );
    node.marks.forEach((mark) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const op = renderMarkup[mark.type];
        if (op) result = op(result);
    });
    return result;
}

const Hyperlink: FC<React.PropsWithChildren<Props>> = ({ nodeData }) => {
    const href = nodeData?.data?.uri;
    const isExternalLink = isExternalUri(href);
    const hrefProps = {
        eventHref: trailingSlashCheck(href),
        target: isExternalLink ? '_blank' : undefined,
        eventAction: isExternalLink ? 'clickout' : 'clickthrough',
        noFollow: isExternalLink ? 'nofollow' : undefined,
        href: isExternalLink ? href : trailingSlashCheck(href)
    };

    return (
        <Link
            href={hrefProps.href}
            target={hrefProps.target}
            rel={hrefProps.noFollow}
            onClick={function () {
                triggerTracking({
                    event: GA_CUSTOM_EVENT,
                    eventCategory: GA_CUSTOM_CATEGORY,
                    eventAction: hrefProps.eventAction,
                    eventLabel: `body link,${hrefProps.eventHref.replace(
                        MAIN_SITE_LINK,
                        ''
                    )}`
                });
            }}
        >
            {nodeData?.content.map(renderNodeMarks)}
        </Link>
    );
};

export default Hyperlink;
